import { CompanyGroup } from '@shared/models/company-group';
import { TenantName } from '@shared/models/tenant-name';

export enum ModuleAction {
    All = '*',
    Create = 'create',
    View = 'view',
    Update = 'update',
    Delete = 'delete',
    Export = 'export',
    Approve = 'approve'
}
export class ActionRole {
    allow_all?: boolean;
    can_create?: boolean;
    can_view?: boolean;
    can_update?: boolean;
    can_delete?: boolean;
    can_export_excel?: boolean;
    can_approve?: boolean;

    constructor(
        allow_all: boolean,
        can_create: boolean,
        can_view: boolean,
        can_update: boolean,
        can_delete: boolean,
        can_export_excel: boolean,
        can_approve: boolean
    ) {
        this.allow_all = allow_all;
        this.can_create = can_create;
        this.can_view = can_view;
        this.can_update = can_update;
        this.can_delete = can_delete;
        this.can_export_excel = can_export_excel;
        this.can_approve = can_approve;
    }
}

export enum AdminModule {
    All = '*',
    Account = 'Account',
    User = 'User',
    UserRole = 'UserRole',
    Contact = 'Contact',
    Document = 'Document',
    Upgrade = 'Upgrade',
    DocumentManagement = 'DocumentManagement',
    TradingAccount = 'TradingAccount',
    TradingAccountRequest = 'TradingAccountRequest',
    Deposit = 'Deposit',
    Withdrawal = 'Withdrawal',
    Transfer = 'Transfer',
    B2BTransfer = 'B2B Transfer',
    CreditCard = 'CreditCard',
    UnionPayCard = 'UnionPayCard',
    BankAccount = 'BankAccount',
    Fasapay = 'Fasapay',
    Bpay = 'Bpay',
    Poli = 'Poli',
    Skrill = 'Skrill',
    XpayThai = 'XpayThai',
    Payout = 'Payout',
    JarvisDepositRepair = 'JarvisDepositRepair',
    RPNDepositRepair = 'RPNDepositRepair',
    PayQuayDepositRepair = 'PayQuayDepositRepair',
    T365DepositRepair = 'T365DepositRepair',
    Leverage = 'Leverage',
    Reward = 'Reward',
    IB = 'IB',
    Partners = 'Partners',
    ReportSymbol = 'ReportSymbol',
    ReportTrade = 'ReportTrade',
    ReportSales = 'ReportSales',
    WatchDog = 'WatchDog',
    FingerPrint = 'FingerPrint',
    RequestFingerprint = 'Request Fingerprint',
    FundOperation = 'FundOperation',
    CreditToBalanceOperation = 'CreditToBalanceOperation',
    GoodwillOperation = 'GoodwillOperation',
    SwapsOperation = 'SwapsOperation',
    RewardOperation = 'RewardOperation',
    XPayOperation = 'XPayOperation',
    XPayThaiOperation = 'XPayThaiOperation',
    IBCreditTransferOperation = 'IBCreditTransferOperation',
    TradingAccountGroup = 'TradingAccountGroup',
    PaymentGateway = 'PaymentGateway',
    PaymentPlatform = 'PaymentPlatform',
    InternalBroker = 'InternalBroker',
    BlackLists = 'BlackList',
    LookupManagement = 'LookupManagement',
    Promotions = 'Promotions',
    CountryLicences = 'CountryLicences',
    NovationRequests = 'NovationRequests',
    BulkTransfer = 'Bulk Transfer'
}

export interface ModulePermission {
    module: AdminModule;
    actions?: ModuleAction[];
}

export class AuthenitcatedUser {
    user_id: string;
    email: string;
    access_token?: string;
    session_token?: string;
    tenant: TenantName;

    get companyGroup(): string {
        return this.tenant ? this.tenant.split('_')[0] : '';
    }

    get permissions(): ModulePermission[] {
        let permissions = [] as ModulePermission[];
        switch (this.companyGroup) {
            case CompanyGroup.EIG:
                permissions = [
                    {
                        module: AdminModule.All,
                        actions: [ModuleAction.All]
                    }
                ];
                break;

            case CompanyGroup.BLU:
                permissions = [
                    {
                        module: AdminModule.Account,
                        actions: [ModuleAction.View]
                    },
                    {
                        module: AdminModule.User,
                        actions: [ModuleAction.View]
                    },
                    {
                        module: AdminModule.Contact,
                        actions: [ModuleAction.View]
                    },
                    {
                        module: AdminModule.Document,
                        actions: [ModuleAction.View]
                    },
                    {
                        module: AdminModule.TradingAccount,
                        actions: [ModuleAction.View]
                    },
                    {
                        module: AdminModule.Withdrawal,
                        actions: [ModuleAction.View]
                    },
                    {
                        module: AdminModule.Deposit,
                        actions: [ModuleAction.View]
                    },
                    {
                        module: AdminModule.Leverage,
                        actions: [ModuleAction.View, ModuleAction.Delete, ModuleAction.Approve]
                    }
                ];
                break;

            default:
                break;
        }

        return permissions;
    }
}
